import { render, staticRenderFns } from "./copygiftcertificate.vue?vue&type=template&id=10c1d40b&scoped=true&"
import script from "./copygiftcertificate.vue?vue&type=script&lang=js&"
export * from "./copygiftcertificate.vue?vue&type=script&lang=js&"
import style0 from "./copygiftcertificate.vue?vue&type=style&index=0&id=10c1d40b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1d40b",
  null
  
)

export default component.exports